import { CheckoutState } from '../../state';
import {
    getIsPaymentView,
    isMyOrderFormPage,
    isOrganizerQuestionsPage,
} from '../routing';
import { getSurvey } from './getSurvey';

export const getIsCurrentPageDisplayingBasicInfoQuestions = (
    state: CheckoutState,
) => {
    const { preOrderConfirmationSurveySettings } = getSurvey(state);

    const displayAttendeeBasicInfoQuestionsAfterPayment =
        preOrderConfirmationSurveySettings.hasRequiredQuestions;
    const isPreOrderOrPreticketsPage =
        isOrganizerQuestionsPage(state) || isMyOrderFormPage(state);

    return displayAttendeeBasicInfoQuestionsAfterPayment
        ? isPreOrderOrPreticketsPage
        : getIsPaymentView(state);
};
